module.exports = __webpack_public_path__ + "static/media/profileLogo.1b080325.jpg";